import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import Logo from "@/components/Logo";
import api, { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-base text-slate-900 placeholder:text-slate-400 focus:border-teal focus:outline-none transition-colors";

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-slate-50 px-4" data-testid="admin-login-page">
      <div className="absolute -right-32 -top-32 h-96 w-96 rounded-full bg-teal-light blur-3xl opacity-70" aria-hidden="true" />
      <div className="relative w-full max-w-md rounded-3xl border border-slate-200 bg-white p-8 shadow-xl shadow-slate-200/60 sm:p-10">
        <Link to="/" aria-label="Back to site" data-testid="admin-login-logo">
          <Logo light={false} />
        </Link>
        <h1 className="mt-8 text-2xl font-bold tracking-tight text-navy">Admin access</h1>
        <p className="mt-2 text-sm text-slate-500">Sign in to manage enquiries and articles.</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label htmlFor="admin-email" className="mb-1.5 block text-sm font-semibold text-slate-700">Email</label>
            <input id="admin-email" data-testid="admin-email-input" type="email" required className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@arms-risk.com" />
          </div>
          <div>
            <label htmlFor="admin-password" className="mb-1.5 block text-sm font-semibold text-slate-700">Password</label>
            <input id="admin-password" data-testid="admin-password-input" type="password" required className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-button"
            className="w-full rounded-full bg-teal py-3.5 text-base font-bold text-white transition-all hover:scale-[1.02] hover:bg-navy disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <Link to="/" className="mt-6 block text-center text-sm text-slate-500 hover:text-teal transition-colors" data-testid="admin-login-back-link">
          ← Back to website
        </Link>
      </div>
    </div>
  );
}
